module.exports = __webpack_public_path__ + "img/prize-02.bf25b7f6.png";